<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Users</mat-card-title>
    <button mat-fab [ngClass]="isSuperAdmin ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
      [disabled]="!isSuperAdmin" (click)="AddUser()" color="accent"
      style="position:absolute; right:20px;top:8px;width: 35px; height:35px;" matTooltip="Add User">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">group_add</i>
      </span>
    </button>
    <button mat-fab (click)="exportExcel()" color="accent"
      style="position:absolute; right:60px;top:8px;width:35px; height:35px;" *ngIf="users != null && users.length >0"
      matTooltip="Download Records">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">download</i>
      </span>
    </button>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
       <div class="row">
      <div class="col-md-8">
      </div>
      <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
          <app-filter-input *ngIf="users!=null && users.length >0" (filterChanged)="applyFilter($event)"></app-filter-input>
      </div>
    </div>
      <div class="table-responsive" style="width:99%;">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
        (matSortChange)="announceSortChange($event)" *ngIf="users != null" aria-label="Table listing users">
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef>S No. </th>
          <td mat-cell *matCellDef="let element; let i= dataIndex;">
            {{dataSource.filteredData.indexOf(element) + 1}}
          </td>
        </ng-container>

        <!-- userId Column not visible -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i=index;"> {{element.id }} </td>
        </ng-container>

        <ng-container matColumnDef="employeeId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Employee Id</th>
          <td mat-cell *matCellDef="let element; let i=index;"> {{element.employeeId | uppercase}} </td>
        </ng-container>

        <!-- brandName Column -->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by firstName"> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.firstName | titlecase}} {{element.lastName | titlecase}}
          </td>
        </ng-container>

        <!-- description Column -->
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by phoneNumber"> Mobile
          </th>
          <td mat-cell *matCellDef="let element"> {{element.phoneNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by email"> Email </th>
          <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <ng-container matColumnDef="roleId">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element"> {{element.roleId}} </td>
        </ng-container>

        <ng-container matColumnDef="roleName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by roleName"> Role Name
          </th>
          <td mat-cell *matCellDef="let element" [matTooltipClass]="'option-tooltip'"
            [matTooltip]="( element.roleName != null && element.roleName.toUpperCase() =='WAREHOUSEMANAGER' ? element.warehouseName : null)">
            {{element.roleName}} </td>
        </ng-container>

        <ng-container matColumnDef="appStatusId">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element"> {{element.appStatusId}} </td>
        </ng-container>

        <ng-container matColumnDef="appuserStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by appuserStatus"> Status
          </th>
          <td mat-cell *matCellDef="let element"> {{element.appuserStatus}} </td>
        </ng-container>

        <!-- isActive Column -->
        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by isActive"> Active </th>
          <td mat-cell *matCellDef="let element"> {{element.isActive}} </td>
        </ng-container>
        <!-- isLocked -->
        <ng-container matColumnDef="isLocked">
          <th mat-header-cell *matHeaderCellDef> Is Locked </th>
          <td mat-cell *matCellDef="let element">
            <button matTooltip="Lock / Unlock password" mat-icon-button aria-label="refresh"
            [disabled]="(!isAdmin && !isSuperAdmin) || (element.appuserStatus =='Inactive')"
              (click)="lockUnlockUser($event, element)"> 
              <mat-icon>{{ element.isLocked ? 'block' : 'lock_open' }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- isDeleted Column -->
        <ng-container matColumnDef="isDeleted">
          <th mat-header-cell *matHeaderCellDef> Deleted </th>
          <td mat-cell *matCellDef="let element"> {{element.isDeleted}} </td>
        </ng-container>

        <ng-container matColumnDef="reset">
          <th mat-header-cell *matHeaderCellDef> Reset Pass </th>
          <td mat-cell *matCellDef="let element">
            <button matTooltip="Reset password" mat-icon-button aria-label="refresh"
            [disabled]="(!isAdmin && !isSuperAdmin) || (element.appuserStatus =='Inactive')"
              (click)="resetPassword($event, element)">
              <mat-icon>refresh</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="Edit" [disabled]="!isAdmin && !isSuperAdmin"
              (click)="editUser($event, element)">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"  ></tr>
      </table>
    </div>
      <mat-paginator [length]=resultLength pageSize="10" [pageSizeOptions]="[ 10, 25, 50, 100]"
        aria-label="Select page"></mat-paginator>
      <div *ngIf="isLoaderResult" class="custSpinner">
      </div>
    </mat-card-content>
  </mat-card>
</div>